import styled from "styled-components";

export const FileInput = styled.input `
height: 100%;
opacity: 0;
-moz-opacity: 0;
-webkit-opacity: 0;
position: absolute;
width: 100%;
z-index: 1;
right: 0;
top: 0;
`;

export const FileInputWrapper = styled.div`
	float: inherit;
	position: relative;
	display: inline-block;
	text-align: center;
	width: 100%;
	height: 115px;
	border-radius: 12px;
	border: dashed 1px #A8ACB8;
	background-color: #F5F6F7;
`;

export const Uploader = styled.div`
	height: 100%;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
	z-index: 0;

	padding: 16px;
`

export const FileUploaded = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 16px;
	align-self: stretch;
	border-radius: 16px;
	background: var(--Greyscale-GREY-050, #EBEDEF);
	height: 100%;

	padding: 16px;
`;

export const RemoveDoc = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 4px;
	align-self: stretch;
	margin-top: 16px;
`;
export const FileInfo = styled.div`
	width: 100%;
`;
